<div style="width: 100%;">
  <input style="max-width:80%;" type="checkbox" name="chkDocType" id="chk_{{cat.CategoryID}}" [checked]="cat.Selected" (change)="chkDocType_Change(cat)" />
  <label for="chk_{{cat.CategoryID}}">{{cat.Name}}</label>
  <span style="line-height:22px;vertical-align:top;">
    <fa-icon *ngIf="IsTolomaticUser" [icon]="faPenToSquare" (click)="EditCategory(cat.CategoryID)" class="fa-light  clickable blue-color"></fa-icon> &nbsp; <fa-icon *ngIf="IsTolomaticUser" [icon]="faX" (click)="DeleteCategory(cat)" class="fa-light clickable blue-color"></fa-icon>
  </span>
  <div style="margin-left:10px;">    
    <app-category-tree *ngFor="let catChild of cat.Children" [IsTolomaticUser]="IsTolomaticUser" (EditCategoryClick)="EditCategoryClick($event)" [cat]="catChild">
    </app-category-tree>    
  </div>
</div>
